import { PayloadAction } from '@reduxjs/toolkit'
import { reducerCreatorProducer } from 'store/common'
import type { ISoundsGenre, IAudioState } from 'store/types/audio'
import { IUserAudio } from 'store/types/audio'
import { sortGenresByNameInAlphabeticalOrder } from 'consts/audio'

const reducers = reducerCreatorProducer<IAudioState>()({
  setSoundsGenres: (state, action: PayloadAction<ISoundsGenre[]>) => {
    state.soundsGenres = sortGenresByNameInAlphabeticalOrder(action.payload)
  },
  setUserSounds: (state, action: PayloadAction<IUserAudio[]>) => {
    state.userSounds = action.payload
  },
  deleteUsersSound: (state, action: PayloadAction<number>) => {
    state.userSounds = state.userSounds.filter(
      sound => sound.id !== action.payload
    )
  },
  unshiftUserSound: (state, action: PayloadAction<IUserAudio[]>) => {
    state.userSounds.unshift(...action.payload)
  },
  setUsedLibSounds: (state, action: PayloadAction<IUserAudio[][]>) => {
    state.usedLibSounds = action.payload
  }
})

export default reducers
